import Component from "../abstracts/Component";

export default class TrackingComponent extends Component {

  get SELECTORS() {
    return {
      dataTracking: '[data-tracking-action]',
      fitersInput: '.js-filters-checkbox',
      trackingPayload: '[data-tracking-payload]',
      cartPage: '.t-cart',
      O2OCCSearchInput: '#pb_sl-search-input',
    }
  }

  // retrieve object/sub-object identified by [data-tracking-payload] attribute and parse them with .data() method
  // to retriieve product JSON
  getTrackingPayloadData(el, list) {
    let elements;

    if (list == true) {
      elements = $(el).find(this.SELECTORS.trackingPayload);
    } else {
      elements = $(el).closest(this.SELECTORS.dataTracking).find(this.SELECTORS.trackingPayload);
    }

    let products = [];
    elements.each(function () {
      products.push($(this).data());
    });
    return products;
  }

  constructor() {
    super();
    this.actions = {
      // action triggered on clicking on "view more" button in listing
      // template ajax/t-category.jsp should add html tag with product-related + SELECTORS.trackingPayload data attributes
      loadMore: (payload) => {
        if (payload != null) {
          let products = this.getTrackingPayloadData($.parseHTML(payload), true);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          try {
            this.log("tracking loadMore event with " + products.length + " more products");
            window.listViewMore(products);
          } catch(e) {
            this.log("listViewMore tracking function not available");
          }
        }
      },

      // from category listing or search listin on clicking product box
      productView: (params, el) => {
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          // looking for first children of [data-tracking-action] el, with [data-tracking-payload] data attribute
          let product = products[0];

          // TODO: add other templates..
          if (typeof product.template !== 'undefined') {
            if ("wishlist-page" === product.template || "category-page" === product.template || "na:t-editorial-listing" === product.template || "na:t-editorial" === product.template || "na:t-salesv2" === product.template || "na:t-salesv2-category" === product.template) {
              try {
                this.log("tracking listProdClick event for product: " + product.id);
                window.listProdClick(product);
              } catch(e) {
                this.warn("listProdClick tracking function not available");
              }
            } else if ("search-page" === product.template) {
              try {
                this.log("tracking searchProdClick event for product: " + product.id);
                window.searchProdClick(product);
              } catch(e) {
                this.warn("searchProdClick tracking function not available");
              }
            } else if ("product-page" === product.template) {
              if (this.isParent("[data-name='crosselling']", el)) {
                try {
                  this.log("tracking listCarouselClick event from 'wear it with' for product: " + product.id);
                  window.listCarouselClick('wear it with', product);
                } catch(e) {
                  this.warn("listCarouselClick tracking function not available");
                }
              } else {
                try {
                  this.log("tracking listCarouselClick event for product: " + product.id);
                  window.listCarouselClick('carousel', product);
                } catch(e) {
                  this.warn("listCarouselClick tracking function not available");
                }
              }
            } else if ("na:c-recommendation-engine" === product.template) {
              try {
                this.log("tracking listCarouselClick event from 'recommendation-engine' for product: " + product.id);
                window.listCarouselClick('recommendation-engine', product);
              } catch(e) {
                this.warn("listCarouselClick tracking function not available");
              }
            }
          }
        }
        if ("algolia" === params.algolia){
          this.log('algolia ' + params);
          params.position = params.position + 1; //Algolia è 1-based e non 0-based
          this.log("Algolia " + params.position + ' ' + params.productId);
          $.ajax({
            url: 'action/ajax/algolia-notification',
            type: 'post',
            cache: 'false',
            data: {
              positionId: params.position,
            },
            success: function (data) {
              this.log('algolia success')
            },
            error: function (errorObj, textStatus, errorThrown) {
              this.warn('algolia error')
            }
          });
        }
      },
      miniPreview: (params) => {
        var productCodeList = params.productCodeList;
        if (typeof productCodeList === 'undefined') {
          this.warn('no productCodeList found');
          return;
        }
        try {
          const codeListString = App.Components.Tracking.getListString(productCodeList);
          this.log('[Tracking] code list: ' + codeListString);
          mm_mini_preview(codeListString);
        } catch (e) {
          this.warn('Utag tracking not available');
        }
      },
      wishlistAdd: (params) => {
        let productCode = params.productCode;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('tracking add to wishlist event with code: ' + productCode);
          utag.wishlist_add(';' + productCode);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      addToCart: (params) => {
        let productCode = params.productCode;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('tracking add to cart event with code: ' + productCode);
          utag.cart_add(';' + productCode);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      login: (params) => {
        try {
          this.log('Tracking login event: loginType - ' + params.loginType);
          utag.link({
            event_name: "login",
            login_type: params.loginType
          });
        } catch(e) {
        this.warn("Utag tracking not available");
        }
      },
      removeProduct: (params) => {
        let productCode = params.productCode;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('tracking removeProduct event with productCode: ' + params.productCode);
          var data = new Object();
          data['event_name'] = 'remove_from_cart';
          data['store_country'] = params.storeCountry,
          data['user_type'] = params.userType,
          data['page_type'] = params.pageType,
          data['page_name'] = params.pageName,
          data['sf_id'] = params.salesforceId,
          data['value'] = params.value,
          utag.link(data)
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      removeQuantity: (params) => {
        let productCode = params.productCode
        let price = params.price
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        if (typeof price === 'undefined') {
          this.warn('no price found');
          return;
        }
        try {
          this.log('tracking removeQuantity event with productCode: ' + params.productCode);
          utag.cart_minus_click(productCode, 1, price);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      addQuantity: (params) => {
        let productCode = params.productCode
        let price = params.price
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        if (typeof price === 'undefined') {
          this.warn('no price found');
          return;
        }
        try {
          this.log('tracking addQuantity event with productCode: ' + params.productCode);
          utag.cart_plus_click(productCode, 1, price);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      newsletter: (params) => {
        const pos = params.pos;
        const type = params.type ? "-" + params.type : '';
        this.log('[Tracking] NL-Subscription, type: ' + type + ' pos: ' + pos);
        ga('send', 'event', 'NL', 'NL-Subscription' + type, pos);
      },
      formisimo: (params) => {
        this.log("formisimo: ", params);
        if (typeof window.TealiumConversionForm == "function") {
          this.log("TealiumConversionForm: ", params);
          window.TealiumConversionForm(params.formId, params.result);
        } else {
          //keep data in a global var
          window.Tealium.trackingData = {
            formId: params.formId,
            formResult: params.result
          }
        }
      },
      sizeSelection: (params) => {
        let code = params.code;
        if (typeof code === 'undefined') {
          this.warn('no code found');
          return;
        }
        try {
          this.log('tracking sizeSelection event with code: ' + code);
          utag.size_selection();
          let mainSizeRow = document.querySelector('.c-sizes-row');
          mainSizeRow.dataset.errorMessage = '';
        } catch (e) {
          this.warn('Utag tracking is not available');
        }
      },
      O2OCCSelect: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        try {
          this.log('tracking 020 CC selected event');
          utag.click_collect('click');
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCSearch: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        let o2oCCSearchInput = $(this.SELECTORS.O2OCCSearchInput).val();
        try {
          this.log('tracking 020 CC store search event: ' + o2oCCSearchInput);
          utag.click_collect(o2oCCSearchInput);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCLocalize: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        try {
          this.log('tracking 020 CC localize event');
          utag.click_collect('localizza');
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCSelectStore: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        let storeName = params.storeName;
        if (typeof storeName === 'undefined') {
          this.warn('no storeName found');
          return;
        }
        try {
          this.log('tracking 020 CC store select event: ' + storeName);
          utag.click_collect("store:" + storeName);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      sortTracking: (sortName, sortMethod, sortType) => {
        let sortCode = "orderBy";
        if(sortName) {
          this.log("triggering filter " + sortCode + ": " + sortName);

          try {
            console.log("tracking link event: " + sortName);
            utag.link({
              filter: sortCode + ":" + sortName,
              sorting_method: sortMethod,
              sorting_type: sortType,
              event_name: "filter_usage"
            });
          } catch(e) {
            console.warn("utag tracking not available");
          }
        }
      },
      startChat: () => {
        try {
          this.log("tracking startChat event");
          utag.link({
            event_name: "chat_start"
          });
        }
        catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      deleteChat: () => {
        try {
          this.log("tracking deleteChat event");
          utag.link({
            event_name: "chat_delete"
          });
        }
        catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      addCartGiftCard: (params) => {
        try {
          this.log("tracking addCartGiftCard event");
          utag.link({
            event_category: "gift card",
            event_action: "add to cart",
            event_label: "giftcart " + params,
            event_name: "giftcart_add_to_cart"
          });
        }
        catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      newsletterSubscribe: (params) => {
        try {
          this.log("tracking newsletterSubscribe event");
          let position = params.trackingPosition;
          utag.link({
            event_name: "newsletter_subscribe",
            event_location: position
          });
        }
        catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      whatsappStart: () => {
        try {
          this.log("tracking whatsappStart event");
          utag.link({
            event_name: "whatsapp_start"
          });
        }
        catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      register: (params) => {
        if(params && params[0]) {
          var data = params[0];
          this.log("Triggering register tracking");
          try {
            this.log('tracking register event: ' + data);
            utag.link({
              event_name: data.eventName,
              page_name: data.pageName,
              page_type: data.pageType,
              login_type: data.userType,
              store_country: data.storeCountry,
              event_method: data.eventMethod
            });
          } catch(e) {
            this.warn("Utag tracking not available");
          }
        }
      },
      shortcutCategoryView: (params) => {
        try {
          this.log('Tracking shortcut category click: ' + params.shortcutLabel);
          var data = new Object();
          data['event_name'] = 'select_content';
          data['event_location'] = params.shortcutNumber// es. shortcut-micro_1, shortcut-macro_4 …
          data['event_detail'] = params.shortcutLabel// es. our selection, clothing, pantaloni, abiti, …
          data['content_type'] = params.shortcutType// es. shortcut-micro, shortcut-macro…
          utag.link(data)
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },

    }
  }

  isCartPage() {
    let element = $(this.SELECTORS.cartPage);
    if (element.length > 0) {
      return true;
    }
    return false;
  }

  isLogged() {
    const locationPath = window.location + "";
    return locationPath.split("/")[3].split("?")[1] === "login=success"
  }

  getListString(codeList) {
    let listString = ";";

    $.each(codeList, function (index, value) {
      listString += value + ",;";
    });

    listString = listString.substr(0, listString.lastIndexOf(","));
    return listString;
  }
  isParent(parentSelector, childEl) {
    if(childEl != null && typeof childEl !== 'undefined' && parentSelector!=null) {
      try {
        let parent = document.querySelector(parentSelector);
        if (parent != null) {
          if (parent.contains(childEl)) {
            return true;
          }
        }
      } catch (e) {
        return false;
      }
    }
    return false;
  }

  isLookOnload() {
    if (document.querySelector('html').getAttribute('data-controller')==='PdpController') {
      let elem = document.querySelector("[data-name='crosselling']");
      if (typeof elem === 'undefined' || elem == null) {
        this.log('No "wear it with" carousel found');
        return;
      }
      try {
        let products = this.getTrackingPayloadData(elem.children, true);
        if (products.length == 0 || typeof products === 'undefined') {
          this.warn('no products found in ' + elemName + ' carousel');
          return;
        }
        try {
          this.log('tracking "wear it with" carousel with ' + products.length + ' products');
          window.listCarouselImpression("wear it with", products);
        } catch(e) {
          this.warn('listCarouselImpression tracking not available');
        }
      } catch(e) {
        this.warn('"wear it with" carousel tracking not available');
      }
    }
  }

  trackAction(action, data, targetElement) {
    if (this.actions[action]) {
      if (typeof data['bs.tab'] != 'undefined') {
        delete data['bs.tab'];
      }
      this.log('[Tracking] tracking action caught: ' + action + ' - with params: ' + JSON.stringify(data));
      this.actions[action](data, targetElement);
    } else {
      this.warn('[Tracking] no tracking manager found for action ' + action);
    }
  }

  bindEvents() {
    this.$on('click', ({event}) => {
      if (!$(event.currentTarget).data('disabled') && $(event.currentTarget).data('trackingAction')) {
        let data = $(event.currentTarget).data();
        let action = data.trackingAction;
        this.trackAction(action, data, event.target);
      }
    }, 'body', this.SELECTORS.dataTracking);

    this.$on('click.tracking', ({event}) => {
      const facetCode = $(event.currentTarget).attr("data-facet-code");
      const facetValue = $(event.currentTarget).attr("data-code");

      this.log("Triggering filter " + facetCode + ": " + facetValue);
      if ($(event.currentTarget).attr('checked') !== 'checked') {
        try {
          this.log('tracking link event: ' + facetValue);
          utag.link({
            filter: facetCode + ":" + facetValue,
            event_name: "filter_usage"
          });
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      }
    }, 'body', this.SELECTORS.fitersInput);
    if (this.isLogged()) {
      this.trackAction('login');
    }
  }

  bindCustomEvents() {
    // ??? custom "track" events
    $('body').on('track', (e, action, params) => {
      const data = [].slice.call(arguments).splice(2);
      this.trackAction(action, data);
    });

    // tracking loadMore button
    this.$on(this.$customEvents.TRACKING.loadMore, (e) => {
      this.log("emitting tacking event: " + this.$customEvents.TRACKING.loadMore);
      this.actions["loadMore"](e.payload);
    });
  }

  initiateTracking() {
    const ctx = this;
    const $formisimo = $('formisimo');
    window.Tealium = {};

    if ($formisimo.length > 0) {
      $formisimo.each(function () {
        const $this = $(this);
        const data = [{'formId': $this.data('formId'), 'result': $this.data('formResult')}];
        ctx.trackAction('formisimo', data);
      });
    }
  }

  render() {
    this.initiateTracking();
    this.bindEvents();
    this.bindCustomEvents();
    window.addEventListener('load', (event) => {
      this.isLookOnload();
    });
  }
}
